import samplePage from './sample-page';
import pages from './pages';
import other from './other';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [samplePage, pages, other]
};

export default menuItems;
